import { Box, Paper, Typography } from '@mui/material';

interface CheckEmailViewProps {
  email: string;
}

export function CheckEmailView({ email }: CheckEmailViewProps) {
  return (
    <Box
      sx={{
        height: '100vh',
        bgcolor: 'grey.100',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        pt: { xs: 4, sm: 8 },
      }}
    >
      <Paper
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
          maxWidth: '430px',
          width: '100%',
          mt: { xs: 5, sm: 10 },
          mx: { xs: 2, sm: 0 },
        }}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          Revisa tu correo electrónico
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Te hemos enviado un enlace para restablecer tu contraseña a{' '}
          <strong>{email}</strong>.
        </Typography>
        <Typography variant="body1">
          Asegúrate de que el correo ingresado sea correcto y esté asociado a
          una cuenta.
        </Typography>
      </Paper>
    </Box>
  );
}
